import { DatePicker } from "antd";
import moment from "moment-timezone";

import * as theme from "./FilterBarPeriodTimeRange.css";
import { PeriodTimeRangeFilterValue } from "./FilterBarPeriodTimeRangeTypes";
import { toPeriodFilterValue } from "./FilterBarPeriodTimeRangeUtils";

const { RangePicker } = DatePicker;

type RangePickerValue = [moment.Moment | null, moment.Moment | null];

// The picker drives server-side period filters, so we deliberately don't pass faceted values
export interface FilterBarPeriodTimeRangeProps {
    filterValue: PeriodTimeRangeFilterValue;
    setFilterValue: (value: PeriodTimeRangeFilterValue) => void;
    allowEmpty: [boolean, boolean];
}

export function FilterBarPeriodTimeRange({
    filterValue,
    setFilterValue,
    allowEmpty,
}: FilterBarPeriodTimeRangeProps) {
    const value: RangePickerValue = [
        filterValue?.[0] ? moment(filterValue[0]) : null,
        filterValue?.[1] ? moment(filterValue[1]) : null,
    ];

    const handleChange = (value: RangePickerValue | null) => {
        setFilterValue(toPeriodFilterValue(value));
    };

    return (
        <RangePicker
            className={theme.periodRange}
            picker="month"
            format="MMMM YYYY"
            onChange={(value) => handleChange(value)}
            value={value}
            allowEmpty={allowEmpty}
            autoFocus
        />
    );
}
